export default __webpack_public_path__ + "static/media/brand_bg02.b633b346.jpg";